export enum MEASURE_TRANSACTION {
  Order = 'delivery',
  Transfer = 'transfer',
  Recipe = 'sale_depletion',
}
